module.exports = __webpack_public_path__ + "static/commercial-property-b1a0293e061c6b533862b8003112801f.jpg";